const alarmDefs = {
    "WarningOrFault01": {
        "0": {
            "ID": "1",
            "Name": "Output-A overcurrent"
        },
        "1": {
            "ID": "2",
            "Name": "Output-B overcurrent"
        },
        "10": {
            "ID": "11",
            "Name": "Inverter-module-B overcurrent"
        },
        "11": {
            "ID": "12",
            "Name": "Inverter-module-C overcurrent"
        },
        "12": {
            "ID": "13",
            "Name": "reserve"
        },
        "13": {
            "ID": "14",
            "Name": "reserve"
        },
        "14": {
            "ID": "15",
            "Name": "reserve"
        },
        "15": {
            "ID": "16",
            "Name": "reserve"
        },
        "2": {
            "ID": "3",
            "Name": "Output-C overcurrent"
        },
        "3": {
            "ID": "4",
            "Name": "Inverter-A overvoltage"
        },
        "4": {
            "ID": "5",
            "Name": "Inverter-B overvoltage"
        },
        "5": {
            "ID": "6",
            "Name": "Inverter-C overvoltage"
        },
        "6": {
            "ID": "7",
            "Name": "Inverter-A undervoltage"
        },
        "7": {
            "ID": "8",
            "Name": "Inverter-B undervoltage"
        },
        "8": {
            "ID": "9",
            "Name": "Inverter-C undervoltage"
        },
        "9": {
            "ID": "10",
            "Name": "Inverter-module-A overcurrent"
        }
    },
    "WarningOrFault02": {
        "0": {
            "ID": "17",
            "Name": "Environmental over-temperature"
        },
        "1": {
            "ID": "18",
            "Name": "IGBT over-temperature"
        },
        "10": {
            "ID": "27",
            "Name": "reserve"
        },
        "11": {
            "ID": "28",
            "Name": "reserve"
        },
        "12": {
            "ID": "29",
            "Name": "reserve"
        },
        "13": {
            "ID": "30",
            "Name": "reserve"
        },
        "14": {
            "ID": "31",
            "Name": "reserve"
        },
        "15": {
            "ID": "32",
            "Name": "reserve"
        },
        "2": {
            "ID": "19",
            "Name": "Soft start pre-charge timeout"
        },
        "3": {
            "ID": "20",
            "Name": "Soft start inverter failed"
        },
        "4": {
            "ID": "21",
            "Name": "Leakage current over-limit"
        },
        "5": {
            "ID": "22",
            "Name": "Battery reverse connection"
        },
        "6": {
            "ID": "23",
            "Name": "Battery undervoltage"
        },
        "7": {
            "ID": "24",
            "Name": "Inverter voltage unbalance"
        },
        "8": {
            "ID": "25",
            "Name": "Grid voltage unbalance"
        },
        "9": {
            "ID": "26",
            "Name": "reserve"
        }
    },
    "WarningOrFault03": {
        "0": {
            "ID": "33",
            "Name": "Grid-AB overvoltage"
        },
        "1": {
            "ID": "34",
            "Name": "Grid-BC overvoltage"
        },
        "10": {
            "ID": "43",
            "Name": "Grid fault ride-through failed"
        },
        "11": {
            "ID": "44",
            "Name": "reserve"
        },
        "12": {
            "ID": "45",
            "Name": "reserve"
        },
        "13": {
            "ID": "46",
            "Name": "reserve"
        },
        "14": {
            "ID": "47",
            "Name": "reserve"
        },
        "15": {
            "ID": "48",
            "Name": "reserve"
        },
        "2": {
            "ID": "35",
            "Name": "Grid-CA overvoltage"
        },
        "3": {
            "ID": "36",
            "Name": "Grid-AB undervoltage"
        },
        "4": {
            "ID": "37",
            "Name": "Grid-BC undervoltage"
        },
        "5": {
            "ID": "38",
            "Name": "Grid-CA undervoltage"
        },
        "6": {
            "ID": "39",
            "Name": "Grid phase reversal"
        },
        "7": {
            "ID": "40",
            "Name": "Grid over frequency"
        },
        "8": {
            "ID": "41",
            "Name": "Grid under frequency"
        },
        "9": {
            "ID": "42",
            "Name": "Islanding protection"
        }
    },
    "WarningOrFault04": {
        "0": {
            "ID": "49",
            "Name": "Semi-bus hardware overvoltage"
        },
        "1": {
            "ID": "50",
            "Name": "Module fan failure"
        },
        "10": {
            "ID": "59",
            "Name": "AC fuse failure"
        },
        "11": {
            "ID": "60",
            "Name": "Wave-by-wave current limiting failure"
        },
        "12": {
            "ID": "61",
            "Name": "Output instantaneous overcurrent"
        },
        "13": {
            "ID": "62",
            "Name": "reserve"
        },
        "14": {
            "ID": "63",
            "Name": "reserve"
        },
        "15": {
            "ID": "64",
            "Name": "reserve"
        },
        "2": {
            "ID": "51",
            "Name": "Dry-contact over-temperature"
        },
        "3": {
            "ID": "52",
            "Name": "Auxiliary power supply failure"
        },
        "4": {
            "ID": "53",
            "Name": "EPO"
        },
        "5": {
            "ID": "54",
            "Name": "DC contactor 1 failure"
        },
        "6": {
            "ID": "55",
            "Name": "DC contactor 2 failure"
        },
        "7": {
            "ID": "56",
            "Name": "DC surge arrester failure"
        },
        "8": {
            "ID": "57",
            "Name": "AC surge arrester failure"
        },
        "9": {
            "ID": "58",
            "Name": "DC fuse failure"
        }
    },
    "WarningOrFault05": {
        "0": {
            "ID": "65",
            "Name": "Voltage AD zero drift over-limit"
        },
        "1": {
            "ID": "66",
            "Name": "Inverter current AD zero drift over-limit"
        },
        "10": {
            "ID": "75",
            "Name": "Inverter voltage instantaneous overvoltage"
        },
        "11": {
            "ID": "76",
            "Name": "Semi-DC instantaneous overvoltage"
        },
        "12": {
            "ID": "77",
            "Name": "DC bus instantaneous overcurrent"
        },
        "13": {
            "ID": "78",
            "Name": "DC bus undervoltage"
        },
        "14": {
            "ID": "79",
            "Name": "DC bus overvoltage"
        },
        "15": {
            "ID": "80",
            "Name": "DC bus unbalance"
        },
        "2": {
            "ID": "67",
            "Name": "Output current AD zero drift over-limit"
        },
        "3": {
            "ID": "68",
            "Name": "DC current AD zero drift over-limit"
        },
        "4": {
            "ID": "69",
            "Name": "Miscellaneous AD zero drift over-limit"
        },
        "5": {
            "ID": "70",
            "Name": "Insulation resistance abnormal"
        },
        "6": {
            "ID": "71",
            "Name": "Inverter voltage DC component over-limit"
        },
        "7": {
            "ID": "72",
            "Name": "Inverter current DC component over-limit"
        },
        "8": {
            "ID": "73",
            "Name": "Inverter module instantaneous overcurrent"
        },
        "9": {
            "ID": "74",
            "Name": "Grid voltage instantaneous overvoltage"
        }
    },
    "WarningOrFault06": {
        "0": {
            "ID": "81",
            "Name": "Parameter initialization failed"
        },
        "1": {
            "ID": "82",
            "Name": "Parameter download failed"
        },
        "10": {
            "ID": "91",
            "Name": "PGA initialization abnormality"
        },
        "11": {
            "ID": "92",
            "Name": "reserve"
        },
        "12": {
            "ID": "93",
            "Name": "reserve"
        },
        "13": {
            "ID": "94",
            "Name": "reserve"
        },
        "14": {
            "ID": "95",
            "Name": "reserve"
        },
        "15": {
            "ID": "96",
            "Name": "reserve"
        },
        "2": {
            "ID": "83",
            "Name": "Carrier synchronization failed"
        },
        "3": {
            "ID": "84",
            "Name": "IF synchronization failed"
        },
        "4": {
            "ID": "85",
            "Name": "Master-slave communication failed"
        },
        "5": {
            "ID": "86",
            "Name": "BMS communication failed"
        },
        "6": {
            "ID": "87",
            "Name": "EMS communication failed"
        },
        "7": {
            "ID": "88",
            "Name": "Backend communication failed"
        },
        "8": {
            "ID": "89",
            "Name": "Discharge prohibited"
        },
        "9": {
            "ID": "90",
            "Name": "Charging prohibited"
        }
    }
}


function parseAlarmData(data) {
    const InverterAlarms = [];
    const BatteryAlarms = []
    for (let i = 1; i < 12; i++) {
        const fn = "WarningOrFault" + i.toString().padStart(2, '0')
        const defs = alarmDefs[fn];
        if (!defs) {
            continue;
        }
        const c = data[fn];
        if (!c) {
            continue;
        }

        for (let j = 0; j < 16; j++) {
            const bit = (c >> j) & 1;
            const def = defs[j];
            if (bit === 1 && def) {
                InverterAlarms.push({"Code": def["ID"], "Name": def["Name"]});
                if (def["ID"] == 22 || def["ID"] == 23) {
                    BatteryAlarms.push({"Code": def["ID"], "Name": def["Name"]});
                }
            }
        }
    }

    return {InverterAlarms, BatteryAlarms};
}

export default {
    parseAlarmData,
}